import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Planning');

export const TREEOBSERVATION_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.TreeObservation.Name')
    .required()
    .minLength(1)
    .maxLength(50)
    .build(),
  FieldBuilder
    .text('code', 'Entity.TreeObservation.Code')
    .required()
    .minLength(1)
    .maxLength(6)
    .build(),
];

export const TREEOBSERVATION_CONFIG = {
  entityName: 'TreeObservation',
  localizationKey: 'Planning::Entity.TreeObservation',
  fields: TREEOBSERVATION_FIELDS,
  permission: 'PlanningInventory.TreeObservations',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Inventory + MENU_NAME_SUFFIX,

};
